import type { QueryClient } from '@tanstack/react-query';

import { meAccessQueryOptions } from '../../../access';
import { notifyLocalSessionChanged } from '../../../session/localSession';
import localStorageStore from '../../../store/localStorageStore';
import { analytics } from '../../analytics';
import { LOGIN_SESSION_START } from '../../analytics/events';
import { trackEvent } from '../../analytics/trackingMiddleware';
import type { OpenedSession, SessionLayout } from '../types/domain.types';

export type LoginMethod = 'passcode' | 'password';

const applyLayout = (layout: SessionLayout): void => {
  localStorageStore.setItem('sideBar', JSON.stringify(layout.sideBar));
  localStorageStore.setItem('landingPage', layout.landingPage);
};

export const openLocalSession = (session: OpenedSession, method: LoginMethod = 'passcode'): void => {
  localStorageStore.setItem('userId', session.userId);
  localStorageStore.setItem('userid', session.userId);
  localStorageStore.setItem('userName', session.userName);
  localStorageStore.setItem('email', session.email);
  localStorageStore.setItem('isStaff', JSON.stringify(session.isStaff));
  localStorageStore.setItem('role', '');
  localStorageStore.setItem('allowAction', JSON.stringify(true));
  if (session.layout !== null) applyLayout(session.layout);
  void analytics.identifyUser({ distinctId: session.userId, userProperties: { name: session.userName } });
  trackEvent(LOGIN_SESSION_START, { method });
};

export const startSession = (queryClient: QueryClient, session: OpenedSession, method: LoginMethod = 'passcode'): void => {
  queryClient.clear();
  if (session.access !== null) queryClient.setQueryData(meAccessQueryOptions().queryKey, session.access);
  openLocalSession(session, method);
  notifyLocalSessionChanged();
};

export const hasLocalSession = (): boolean => Boolean(localStorageStore.getItem('userId'));

export interface LocalPerson {
  readonly userId: string;
  readonly name: string;
}

export const localSessionPerson = (): LocalPerson | null => {
  const userId = localStorageStore.getItem('userId');
  return userId ? { userId, name: localStorageStore.getItem('userName') ?? '' } : null;
};
